import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const PrivacyPolicy: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="login-container">
      <div className="privacy-container">
        <div className="privacy-header">
          <button className="back-btn" onClick={() => navigate('/')}>
            ← Ana Sayfaya Dön
          </button>
          <h1>Gizlilik Politikası ve KVKK</h1>
          <p>Son güncelleme: 1 Ocak 2025</p>
        </div>

        <div className="privacy-content">
          <section>
            <h2>1. Giriş</h2>
            <p>
              Taxicim olarak, kişisel verilerinizin güvenliği ve gizliliği bizim için en önemli önceliktir. 
              Bu gizlilik politikası, 6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) uyarınca 
              hazırlanmış olup, kişisel verilerinizin nasıl toplandığı, işlendiği, korunduğu ve 
              paylaşıldığı hakkında bilgi vermektedir.
            </p>
          </section>

          <section>
            <h2>2. Veri Sorumlusu</h2>
            <p><strong>Veri Sorumlusu:</strong> Taxicim</p>
            <p><strong>Adres:</strong> Atatürk Mah. Ertuğrul Gazi Sok. Metropol İstanbul A Blok Apt No:2E Kat:21 Daire:331 Ataşehir / İstanbul</p>
            <p><strong>İletişim:</strong> info@taxicim.com.tr</p>
            <p><strong>Telefon:</strong> 0850 304 06 28</p>
          </section>

          <section>
            <h2>3. Toplanan Kişisel Veriler</h2>
            <h3>3.1 Yolcular İçin:</h3>
            <ul>
              <li>Ad, soyad</li>
              <li>E-posta adresi</li>
              <li>Telefon numarası</li>
              <li>Konum bilgileri</li>
              <li>Yolculuk geçmişi</li>
              <li>Ödeme bilgileri</li>
              <li>Cihaz ve uygulama kullanım bilgileri</li>
            </ul>

            <h3>3.2 Sürücüler İçin:</h3>
            <ul>
              <li>Ad, soyad</li>
              <li>E-posta adresi</li>
              <li>Telefon numarası</li>
              <li>Ehliyet bilgileri</li>
              <li>Araç bilgileri (plaka, model, renk)</li>
              <li>Konum bilgileri</li>
              <li>Finansal bilgiler</li>
              <li>Performans ve değerlendirme bilgileri</li>
            </ul>
          </section>

          <section>
            <h2>4. Kişisel Verilerin İşlenme Amaçları</h2>
            <ul>
              <li>Taksi hizmetinin sunulması ve yönetimi</li>
              <li>Güvenlik ve emniyet sağlanması</li>
              <li>Müşteri hizmetlerinin sunulması</li>
              <li>Ödeme işlemlerinin gerçekleştirilmesi</li>
              <li>Hukuki yükümlülüklerin yerine getirilmesi</li>
              <li>İstatistiksel analizler yapılması</li>
              <li>Hizmet kalitesinin artırılması</li>
            </ul>
          </section>

          <section>
            <h2>5. Kişisel Verilerin Paylaşılması</h2>
            <p>
              Kişisel verileriniz, KVKK hükümleri çerçevesinde aşağıdaki durumlarda 
              üçüncü kişilerle paylaşılabilir:
            </p>
            <ul>
              <li>Yasal yükümlülüklerin yerine getirilmesi</li>
              <li>Resmi makamların talebi</li>
              <li>Hizmet sağlayıcılarla (ödeme sistemleri, harita servisleri)</li>
              <li>Güvenlik ve emniyet için gerekli durumlarda</li>
            </ul>
          </section>

          <section>
            <h2>6. Kişisel Verilerin Korunması</h2>
            <p>
              Kişisel verileriniz teknik ve idari tedbirlerle korunmaktadır:
            </p>
            <ul>
              <li>SSL şifreleme teknolojisi</li>
              <li>Güvenli veri depolama sistemleri</li>
              <li>Erişim kontrolü ve yetkilendirme</li>
              <li>Düzenli güvenlik denetimleri</li>
              <li>Çalışan eğitimleri</li>
            </ul>
          </section>

          <section>
            <h2>7. KVKK Haklarınız</h2>
            <p>KVKK'nın 11. maddesi uyarınca sahip olduğunuz haklar:</p>
            <ul>
              <li>Kişisel veri işlenip işlenmediğini öğrenme</li>
              <li>İşlenen kişisel veriler hakkında bilgi talep etme</li>
              <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
              <li>Yurt içinde/dışında aktarılan üçüncü kişileri bilme</li>
              <li>Eksik/yanlış işlenmiş verilerin düzeltilmesini isteme</li>
              <li>Silme/yok edilme talep etme</li>
              <li>Düzeltme/silme işlemlerinin paylaşılan üçüncü kişilere bildirilmesini isteme</li>
              <li>Zarar giderimi talep etme</li>
            </ul>
          </section>

          <section>
            <h2>8. Çocukların Gizliliği</h2>
            <p>
              Uygulamamız 13 yaşından küçük çocuklara yönelik değildir. 
              13 yaşından küçük çocuklardan bilerek kişisel veri toplamayız.
            </p>
          </section>

          <section>
            <h2>9. Konum Verileri</h2>
            <p>
              Konum verileriniz sadece hizmet sunumu için kullanılır ve 
              izniniz olmadan üçüncü kişilerle paylaşılmaz. Konum izinini 
              istediğiniz zaman cihaz ayarlarından kapatabilirsiniz.
            </p>
          </section>

          <section>
            <h2>10. Çerezler (Cookies)</h2>
            <p>
              Web sitemizde kullanıcı deneyimini iyileştirmek için çerezler 
              kullanılmaktadır. Çerez tercihlerinizi tarayıcı ayarlarından 
              yönetebilirsiniz.
            </p>
          </section>

          <section>
            <h2>11. Değişiklikler</h2>
            <p>
              Bu gizlilik politikası gerektiğinde güncellenebilir. 
              Önemli değişiklikler uygulama üzerinden bildirilecektir.
            </p>
          </section>

          <section>
            <h2>12. İletişim</h2>
            <p>
              KVKK haklarınızı kullanmak veya gizlilik konularında 
              sorularınız için bize ulaşabilirsiniz:
            </p>
            <p><strong>E-posta:</strong> kvkk@taxicim.com.tr</p>
            <p><strong>Telefon:</strong> 0850 304 06 28</p>
            <p><strong>Posta:</strong> Atatürk Mah. Ertuğrul Gazi Sok. Metropol İstanbul A Blok Apt No:2E Kat:21 Daire:331 Ataşehir / İstanbul</p>
          </section>

          <section>
            <h2>13. Üçüncü Taraf Reklam ve Analiz Araçları</h2>
            <p>
              Web sitemiz ve uygulamamızda; Facebook (Meta) Pixel, Google Analytics/Ads, TikTok Pixel gibi üçüncü taraf reklam ve analiz araçları kullanılmaktadır. Bu araçlar, kullanıcı davranışlarını analiz etmek, reklamları optimize etmek ve size daha iyi bir deneyim sunmak amacıyla çerezler ve benzeri teknolojiler aracılığıyla veri toplayabilir.
            </p>
            <ul>
              <li>Facebook/Meta Pixel: Facebook ve Instagram reklamlarının ölçülmesi ve hedeflenmesi için kullanılır.</li>
              <li>Google Analytics ve Google Ads: Ziyaretçi istatistikleri ve reklam performansı için kullanılır.</li>
              <li>TikTok Pixel: TikTok reklamlarının ölçülmesi ve hedeflenmesi için kullanılır.</li>
            </ul>
            <p>
              Bu araçlar, IP adresiniz, cihaz bilgileriniz, ziyaret ettiğiniz sayfalar ve tıklama davranışlarınız gibi verileri toplayabilir. Toplanan veriler, ilgili üçüncü tarafların sunucularına aktarılabilir ve kendi gizlilik politikalarına tabi olarak işlenebilir.
            </p>
            <p>
              <strong>Reklam Tercihleri:</strong> Dilerseniz Facebook, Google ve TikTok gibi platformların reklam tercihleri sayfalarından ilgi alanına dayalı reklamları devre dışı bırakabilirsiniz. Ayrıca tarayıcı ayarlarınızdan çerezleri yönetebilir veya silebilirsiniz.
            </p>
            <p>
              Daha fazla bilgi için ilgili platformların gizlilik politikalarını inceleyebilirsiniz:
              <ul>
                <li><a href="https://www.facebook.com/privacy/policy" target="_blank" rel="noopener noreferrer">Meta (Facebook) Gizlilik Politikası</a></li>
                <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Gizlilik Politikası</a></li>
                <li><a href="https://www.tiktok.com/legal/page/row/privacy-policy/tr" target="_blank" rel="noopener noreferrer">TikTok Gizlilik Politikası</a></li>
              </ul>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 